// eslint-disable-next-line import/prefer-default-export
export const colors = {
  chessboardBrown: '#A5682A',
  black: '#000000',
  red: '#C73B0F',
  white: '#ffffff',
};
